<template>
    <vx-expandable-card>
        <template v-slot:header>Title</template>
        <template v-slot:content>
            <vx-input
                v-model="data.title"
                size="lg"
                maxlength="191"
                :disabled="!props.canEdit"
                data-test="title-input"
                :error="displayFirstError(validation.title.$errors)"
            />
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxExpandableCard, VxInput } from '@voxie/frontend-components';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import type { TermFormData } from '~/services/adminTermsClient.types';

const props = defineProps<{
    canEdit: boolean;
}>();

const data = defineModel<TermFormData>({ required: true });

const validation = useVuelidate(
    {
        title: { required, maxLength: maxLength(191) },
    },
    data
);
</script>
